"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_ORGANIZATIONS = 'LOAD_ORGANIZATIONS';
exports.LOAD_ORGANIZATION = 'LOAD_ORGANIZATION';
exports.SELECT_ORGANIZATION = 'SELECT_ORGANIZATION';
exports.CREATE_ORGANIZATION = 'CREATE_ORGANIZATION';
exports.UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
exports.PUBLISH_ORGANIZATION = 'PUBLISH_ORGANIZATION';
exports.UNPUBLISH_ORGANIZATION = 'UNPUBLISH_ORGANIZATION';
exports.ADD_ORGANIZATION_PERMISSION = 'ADD_ORGANIZATION_PERMISSION';
exports.REMOVE_ORGANIZATION_PERMISSION = 'REMOVE_ORGANIZATION_PERMISSION';
exports.SET_ORGANIZATION_ACCESSIBILITY = 'SET_ORGANIZATION_ACCESSIBILITY';
exports.LOAD_PUBLIC_ORGANIZATIONS = 'LOAD_PUBLIC_ORGANIZATIONS';
exports.LOAD_PUBLIC_ORGANIZATION = 'LOAD_PUBLIC_ORGANIZATION';
exports.LOAD_SITES = 'LOAD_SITES';
exports.LOAD_SITE = 'LOAD_SITE';
exports.SELECT_SITE = 'SELECT_SITE';
exports.CREATE_SITE = 'CREATE_SITE';
exports.UPDATE_SITE = 'UPDATE_SITE';
exports.ADD_SITE_PERMISSION = 'ADD_SITE_PERMISSION';
exports.REMOVE_SITE_PERMISSION = 'REMOVE_SITE_PERMISSION';
exports.SET_SITE_ACCESSIBILITY = 'SET_SITE_ACCESSIBILITY';
exports.LOAD_ORGANIZATION_MEMBERS = 'LOAD_ORGANIZATION_MEMBERS';
exports.LOAD_ORGANIZATION_MEMBER = 'LOAD_ORGANIZATION_MEMBER';
exports.SELECT_ORGANIZATION_MEMBER = 'SELECT_ORGANIZATION_MEMBER';
exports.CREATE_ORGANIZATION_MEMBER = 'CREATE_ORGANIZATION_MEMBER';
exports.UPDATE_ORGANIZATION_MEMBER = 'UPDATE_ORGANIZATION_MEMBER';
exports.ADD_ORGANIZATION_MEMBER_PERMISSION = 'ADD_ORGANIZATION_MEMBER_PERMISSION';
exports.REMOVE_ORGANIZATION_MEMBER_PERMISSION = 'REMOVE_ORGANIZATION_MEMBER_PERMISSION';
exports.SET_ORGANIZATION_MEMBER_ACCESSIBILITY = 'SET_ORGANIZATION_MEMBER_ACCESSIBILITY';
exports.LOAD_PUBLIC_SITES = 'LOAD_PUBLIC_SITES';
exports.LOAD_PUBLIC_SITE = 'LOAD_PUBLIC_SITE';
exports.LOAD_CATEGORIES = 'LOAD_CATEGORIES';
exports.LOAD_CATEGORY = 'LOAD_CATEGORY';
exports.SELECT_CATEGORY = 'SELECT_CATEGORY';
exports.CREATE_CATEGORY = 'CREATE_CATEGORY';
exports.UPDATE_CATEGORY = 'UPDATE_CATEGORY';
exports.PUBLISH_CATEGORY = 'PUBLISH_CATEGORY';
exports.UNPUBLISH_CATEGORY = 'UNPUBLISH_CATEGORY';
exports.ADD_CATEGORY_PERMISSION = 'ADD_CATEGORY_PERMISSION';
exports.REMOVE_CATEGORY_PERMISSION = 'REMOVE_CATEGORY_PERMISSION';
exports.SET_CATEGORY_ACCESSIBILITY = 'SET_CATEGORY_ACCESSIBILITY';
exports.LOAD_PUBLIC_CATEGORIES = 'LOAD_PUBLIC_CATEGORIES';
exports.LOAD_PUBLIC_CATEGORY = 'LOAD_PUBLIC_CATEGORY';